import { render, staticRenderFns } from "./PropertyDescriptions.vue?vue&type=template&id=c515503c&scoped=true"
import script from "./PropertyDescriptions.vue?vue&type=script&lang=ts"
export * from "./PropertyDescriptions.vue?vue&type=script&lang=ts"
import style0 from "./PropertyDescriptions.vue?vue&type=style&index=0&id=c515503c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c515503c",
  null
  
)

export default component.exports